const baseUrl = "https://martial-art-hub-backend.onrender.com/api"
// const baseUrl = "http://localhost:4000/api"

export default baseUrl; 